class CustomBrandCarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.initPages();
  }
  initPages() {
    var imageSplide = new Splide(this.querySelector('.splide'), {
      perPage: 5,
      perMove: 5,
      rewind: false,
      type: 'loop',
      pagination: false,
      gap: 45,
      breakpoints: {
        989: {
          perPage: 3,
          perMove: 3,
          fixedWidth: false,
          gap: 16,
          padding: { left: 0, right: 150 }
        },
        749: {
          perPage: 1,
          perMove: 1,
          fixedWidth: false,
          gap: 16,
          padding: { left: 0, right: 150 }
        },
      }
    });
    var $this = this;
    imageSplide.on('mounted move', function () {
      var num = ~~((imageSplide.index + 1) / imageSplide.options.perPage) + 1;
      var total = parseInt((imageSplide.length - 1) / imageSplide.options.perPage + 1);
      $this.querySelector('.count .num').innerHTML = num;
      $this.querySelector('.count .total-page').innerHTML = total;
    });
    imageSplide.mount();
  }
}

customElements.define('brand-carousel', CustomBrandCarouselComponent);